const COMPONENT_NAME = "CategoryTile";
const INVALID_PROPS_ERROR = `${COMPONENT_NAME}-error: Missing required parameter`;
export {
  COMPONENT_NAME,
  INVALID_PROPS_ERROR
};
